import React from 'react';
import { CheckCircle, Ear, CreditCard, MessageSquare } from 'lucide-react';

const whyChooseUsData = [
  {
    icon: Ear,
    title: 'Escucha real y humana',
    description: 'No te vas a encontrar con un escritorio frío ni palabras técnicas difíciles. Te escuchamos con empatía y nos ponemos en tus zapatos.'
  },
  {
    icon: CreditCard,
    title: 'Transparencia financiera',
    description: 'Te ofrecemos presupuestos claros desde el primer día y modalidades de pago pensadas a tu medida, sin sorpresas de último momento.'
  },
  {
    icon: MessageSquare,
    title: 'Respuestas sin vueltas',
    description: 'Aprovechamos la tecnología para informarte sobre el avance de tu caso vía WhatsApp de forma clara, sin que tengas que moverte de tu casa.'
  }
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us-section">
      <div className="why-choose-us-container">
        <h2 className="why-choose-us-title">Tres razones para confiar en nosotras.</h2>
        <div className="why-choose-us-grid">
          {whyChooseUsData.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div key={index} className="why-choose-us-card">
                <div className="why-icon-wrapper">
                  <IconComponent className="why-icon" />
                </div>
                <h3 className="why-title">{item.title}</h3>
                <p className="why-description">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
